import { useChatList } from '@services/chat/queries/useChatList'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ChatEmptyDescription } from '../ChatEmptyDescription'
import { ChatListItem } from './ChatListItem'

const DEFAULT_PAGE = 1
const DEFAULT_PAGE_SIZE = 6

export function Conversations(props: {
  selectChat: (id?: string) => void
  isActive: boolean
  activeChat?: string
  activeUser?: string
}) {
  const [page, setPage] = useState(DEFAULT_PAGE)
  const pageSize = DEFAULT_PAGE_SIZE
  const chatList = useChatList({
    isActive: props.isActive,
    limit: pageSize,
    offset: (page - 1) * pageSize,
    user: props.activeUser
  })
  const { t } = useTranslation('chat')

  const results = chatList.data?.results ?? []
  const total = chatList.data?.count ?? 0
  const pages = Math.max(1, Math.ceil(total / pageSize))

  return (
    <div className="flex min-h-[500px] flex-col">
      <div className="flex flex-1 flex-col gap-1">
        {results.length === 0 ? (
          <div className="flex flex-1 items-center px-2 py-10">
            <ChatEmptyDescription text={t('form.common.no_messages')} />
          </div>
        ) : (
          results.map((chat) => (
            <ChatListItem
              key={chat.id}
              item={chat}
              onClick={props.selectChat}
            />
          ))
        )}
      </div>

      {pages > 1 && (
        <div className="mt-6 flex items-center justify-center gap-1.5">
          <button
            type="button"
            disabled={page === 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            className="flex h-8 w-8 items-center justify-center rounded-full border-0 bg-transparent p-0 text-ink transition-colors hover:bg-ink/[0.05] disabled:opacity-30"
          >
            <ChevronLeft className="h-4 w-4" />
          </button>
          <span className="px-2 text-sm font-medium text-muted-foreground">
            {page} / {pages}
          </span>
          <button
            type="button"
            disabled={page === pages}
            onClick={() => setPage((p) => Math.min(pages, p + 1))}
            className="flex h-8 w-8 items-center justify-center rounded-full border-0 bg-transparent p-0 text-ink transition-colors hover:bg-ink/[0.05] disabled:opacity-30"
          >
            <ChevronRight className="h-4 w-4" />
          </button>
        </div>
      )}
    </div>
  )
}
